import { Button } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteGalleryByIdFn, getGalleryFn } from "../../Services/Gallery";

const Gallery = () => {
  const navigate = useNavigate();

  const { data: getGallery, refetch } = useQuery({
    queryKey: "get-gallery",
    queryFn: getGalleryFn,
  });

  const { mutate: deleteGalleryId } = useMutation(deleteGalleryByIdFn, {
    onSuccess: () => {
      refetch();
      toast.success("Gallery deleted successfully.");
    },
  });

  const handleDelete = (id) => {
    const formData = new FormData();
    formData.append("gallery_id", id);
    deleteGalleryId(formData);
  };

  return (
    <>
      {/* Heading */}
      <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        Gallery
      </p>

      {/* Add Button */}
      <div className="flex justify-end w-full px-2">
        <NavLink to="/gallery/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-2 py-1">
        {getGallery?.data?.data?.map((item) => (
          <div
            key={item.id}
            onClick={() =>
              navigate("/gallery-image", {
                state: { gallery_id: item.id },
              })
            }
            className="flex flex-col justify-between p-3 border border-gray-300 rounded shadow hover:shadow-lg transition cursor-pointer bg-white"
          >
            {/* Content */}
            <div className="flex flex-col gap-3">
              <p className="text-lg font-semibold text-black">{item.title}</p>

              {item?.image && (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-32 object-cover rounded"
                />
              )}
            </div>

            {/* Actions */}
            <div className="flex justify-center gap-3 pt-4">
              <Button
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/gallery/update", { state: item.id });
                }}
              >
                Update
              </Button>

              <Button
                variant="outlined"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(item.id);
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Gallery;
